import _extends from "@babel/runtime/helpers/esm/extends";
import { useGridAriaAttributesPro, useGridSelector } from '@mui/x-data-grid-pro/internals';
import { gridRowGroupingSanitizedModelSelector } from "../features/rowGrouping/gridRowGroupingSelector.mjs";
import { useGridPrivateApiContext } from "./useGridPrivateApiContext.mjs";
export const useGridAriaAttributesPremium = () => {
  const ariaAttributesPro = useGridAriaAttributesPro();
  const apiRef = useGridPrivateApiContext();
  const gridRowGroupingModel = useGridSelector(apiRef, gridRowGroupingSanitizedModelSelector);
  const ariaAttributesPremium = gridRowGroupingModel.length > 0 ? {
    role: 'treegrid'
  } : {};
  return _extends({}, ariaAttributesPro, ariaAttributesPremium);
};